import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DataService } from '../../services/data.service';

import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector:    'npa-maintenance-dialog',
    templateUrl: './npa-maintenance-dialog.html',
    styleUrls:  ['./npa-maintenance-dialog.scss'],
    providers: [
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [ MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS ]
      },
      {
        provide: MAT_DATE_FORMATS, 
        useValue: MY_FORMATS
      },
    ],
  })

  export class NpaMaintenanceDialog implements OnInit {
  
    constructor(
      private dataService: DataService,
      public npaMaintenance: MatDialogRef<NpaMaintenanceDialog>,
      @Inject( MAT_DIALOG_DATA ) public data: any) { }


    maTypeObj: any;
    maTypeOptions = [];
    filteredMaTypeControl: FormControl = new FormControl();
    filteredMaTypeOptions: Observable<string[]>;
    
    onNoClick(): void {
      this.npaMaintenance.close();
    }
    // =================================================================
    // -- 
    // =================================================================
    ngOnInit() {

      this.maTypeObj     = {};
      this.maTypeOptions = this.dataService.NPAMaintenanceTypes;

      for( var x in this.maTypeOptions ){
        this.maTypeObj[ this.maTypeOptions[ x ] ] = x;
      }

      console.log("maTypeObj",this.maTypeObj);

      this.filteredMaTypeOptions = this.filteredMaTypeControl.valueChanges
      .pipe(
        startWith(''),
        map(val => this.filterMaType(val))
      );


    }
    // =================================================================
    // -- 
    // =================================================================
    filterMaType(val): string[] {
      
      console.log("filteredMaTypeControl",this.filteredMaTypeControl.value);
      console.log("maTypeObj fil",this.maTypeObj[ this.filteredMaTypeControl.value ]);
      if( this.maTypeObj[ this.filteredMaTypeControl.value ] ){
  
        // this.changePort();
  
        // this.http.get('/dtsecured/x/x/' + this.filteredPortControl.value ).subscribe(data => {
        //   // console.log('data :: ', data);
        //   this.port = data;
  
          // this.npaMaintenance[ "MA_TYPE" ] = this.maTypeObj[ this.filteredMaTypeControl.value ];
          // console.log( "npaMaintenance", this.npaMaintenance );
          this.data[ "MA_TYPE" ] = parseInt(this.maTypeObj[ this.filteredMaTypeControl.value ]);
          console.log( "data", this.data );
              
        //   this.kccIds = [];
        //   var lastKccId = "";
        //   var kccid     = "";
        //   var option;
  
        //   for( var x in data ){
  
        //     kccid   = data[ x ][ "KCC_DT_ID" ];
        //     option  = { value: kccid, viewValue: kccid };
  
        //     if( lastKccId == kccid ){
        //       lastKccId = kccid;
        //       continue;
        //     }else{
        //       this.kccIds.push( option );
        //     }
  
  
        //   }
        //   }
        // )
      }
      return this.maTypeOptions.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }
    // =================================================================
    // -- 
    // =================================================================
  
  }